<template>
    <div>        
        <div class="p-grid p-fluid">
            <div class="p-col-12">
                <p style="color:#E55000">*Los archivos a cargar deben ser tal cual se descargan del portal de SmartReporting del Remedy.</p>
            </div>
            <div class="p-col-12">
                <BlockUI :blocked="submittedIncidencias" >
                    <Card>                    
                        <template #title>
                            Carga de Archivos REMEDY Incidencias y Ordenes
                        </template>                        
                        <template #content>              
                                <div class="p-grid p-flex-column">
                                    <div class="p-col">
                                        <h4>Cargar archivo nuevo</h4>          
                                    <div class="p-formgrid p-grid">        
                                            <div class="p-field p-col">
                                                <div class="flex items-center">
                                                    <RadioButton v-model="tipoArchivo" inputId="ingredient1" name="tipo" value="REMEDY_INCIDENCIAS" />
                                                    <label for="ingredient1" class="ml-2">Reporte de incidencias</label>
                                                </div>
                                                <div class="flex items-center mt-2">
                                                    <RadioButton v-model="tipoArchivo" inputId="ingredient3" name="tipo" value="REMEDY_INCIDENCIAS_HISTORICO" />
                                                    <label for="ingredient3" class="ml-2">Reporte de incidencias Historico</label>
                                                </div>
                                                <div class="flex items-center mt-2">
                                                    <RadioButton v-model="tipoArchivo" inputId="ingredient2" name="tipo" value="REMEDY_ORDENES" />
                                                    <label for="ingredient2" class="ml-2">Reporte de ordenes</label>
                                                </div>
                                                <div class="flex items-center mt-2">
                                                    <RadioButton v-model="tipoArchivo" inputId="ingredient4" name="tipo" value="REMEDY_ORDENES_HISTORICO" />
                                                    <label for="ingredient4" class="ml-2">Reporte de ordenes Historico</label>
                                                </div>
                                            </div>                                    
                                            <div class="p-field p-col mt-4">
                                                <FileUpload
                                                    ref="fil"
                                                    mode="basic"
                                                    :maxFileSize="25000000"
                                                    :customUpload="true"
                                                    @uploader="myUploaderIncidencias"
                                                    invalidFileSizeMessage="El archivo debe ser de máximo 25MB"
                                                    chooseLabel="Examinar"
                                                    uploadLabel="Subir"
                                                    @select="archivoSeleccionadoIncidencias"              
                                                />
                                            </div>
                                        </div>                             
                                        <p v-show="muestraMsgIncidencias" style="color:Gray">Pulse de nuevo sobre el botón para enviarlo. El proceso puede tardar varios minutos, por favor no cierre ni actualice la página.</p>                        
                                        
                                    </div>                                    
                                </div>                            
                        </template>                    
                    </Card>
                </BlockUI>                
            </div>
        </div>
    </div>
</template>

<script>
import Srvr from "../../service/remedy/Remedy_incidencias";

export default {
    data(){
        return {
            muestraMsgIncidencias:false,
            submittedIncidencias:false,            
            muestraMsgPersonal:false,
            submittedOrdenes:false,  
            tipoArchivo:"REMEDY_INCIDENCIAS"
        }
    },
    methods: {
        archivoSeleccionadoIncidencias(e){                 
            if(e.files.length>0){
                this.muestraMsgIncidencias = true;
            }
            else{
                this.muestraMsgIncidencias = false;
            }
        },
        myUploaderIncidencias(event) {
            this.submittedIncidencias = true;            
            this.cargaArchivoIncidencias(event.files[0]);
        },
        cargaArchivoIncidencias(mfile) {
            var t = this;

            var file = mfile;
            t.mensajeImam = "";

            var ext = file.name.slice(((file.name.lastIndexOf(".") - 1) >>> 0) + 2);

            if (ext.length > 0 && ext.length <= 4) {
                if (file.size <= 25000000) {
                var ctlSvr = new Srvr();
                var reader = new FileReader();
                var fileByteArray = [];
                reader.readAsArrayBuffer(file);
                reader.onloadend = function (evt) {
                    if (evt.target.readyState == FileReader.DONE) {
                    var arrayBuffer = evt.target.result,
                        array = new Uint8Array(arrayBuffer);
                    for (var i = 0; i < array.length; i++) {
                        fileByteArray.push(array[i]);
                    }

                    var newFileName = file.name; //+ "." + ext;
                    newFileName = newFileName.replace(" ", "");
                    newFileName = newFileName.replace("_", "");
                    //console.log(newFileName);

                    var formData = {
                        fileBytes: fileByteArray,
                        fileNameOrig: newFileName,                        
                        tipo: t.tipoArchivo,                                                
                    };

                    //console.log(formData);

                    ctlSvr.CargaArchivoReportesREMEDY(t, formData).then((res) => {
                        console.log(res);                       
                        t.$refs.fil.clear();   
                        t.submittedIncidencias = false;                     
                    })
                    .catch(function(error){
                            console.log(error);
                            t.submittedIncidencias = false;
                        });
                    }
                };
                } else {
                t.$toast.add({
                    severity: "warn",
                    summary: "ALERTA",
                    detail:
                    "El archivo sobrepasa el limite de 25Mb, por favor intenta con otro archivo",
                    life: 6000,
                });
                }
            } else {
                t.$toast.add({
                severity: "warn",
                summary: "ALERTA",
                detail:
                    "El archivo no cuenta con una extensión de tipo de archivo valida. Intente con otro archivo",
                life: 6000,
                });
            }
        },
    },
    mounted() {
		
	},
}
</script>